import { Link, useMatches } from '@tanstack/react-router';
import { ChevronRight } from 'lucide-react';

export const Breadcrumbs = () => {
  const matches = useMatches();
  const crumbs = matches.filter((m) => m.staticData?.breadcrumb);

  if (crumbs.length === 0) return null;
  return (
    <nav className="flex flex-1 items-center text-base text-gray-500" aria-label="Breadcrumb">
      <ol className="flex items-center gap-2 overflow-x-auto whitespace-nowrap">
        {crumbs.map((match, i) => {
          const Crumb = match.staticData?.breadcrumb;
          const content = typeof Crumb === 'function' ? <Crumb /> : Crumb;
          const isLast = i === crumbs.length - 1;

          return (
            <li key={match.id} className="flex items-center gap-2">
              {i > 0 ? <ChevronRight width={16} className="text-gray-400" aria-hidden /> : null}
              {isLast ? (
                <span className="font-semibold text-gray-900" aria-current="page">
                  {content}
                </span>
              ) : (
                <Link to={match.pathname} className="hover:text-gray-700">
                  {content}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
